"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error when an invalid operation is attempted on a draft object
 * @param {string} courseId
 * @param {string} id
 * @param {string} newParentId
 * @param {action} - move/import
 */
class DraftObjectConflictError extends client_library_1.ExtendableError {
    constructor(courseId, id, newParentId, action) {
        const actionType = action === 'import/batch' ? 'batch import' : action;
        super(`draft object: invalid ${actionType} from id ${id} to new parent id ${newParentId}. courseId: ${courseId}`);
        this.courseId = courseId;
    }
}
exports.default = DraftObjectConflictError;
//# sourceMappingURL=DraftObjectConflictError.js.map